export default "__VITE_ASSET__DtK2EqKo__"